// @ts-nocheck
/* eslint-disable react/forbid-prop-types */
/*!

=========================================================
* Argon Dashboard PRO React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies
or substantial portions of the Software.

*/

// React imports
import React, { useEffect, useMemo } from 'react';

// reactstrap components
import {
  Row, Col
} from 'reactstrap';

// core components
import log from 'loglevel';
import AIAnalysis from '../../../components/RichInsights/AIAnalysis';
import ProfileHeader from '../../../components/Headers/ProfileHeader';

import CustomerPersonas from './CustomerPersonas';
import Visualizations from './Visualizations';

log.setLevel(process.env.NODE_ENV === 'production' ? 'warn' : 'debug');

export default function Home() {
  const rowStyle = useMemo(() => ({
    margin: '0',
    padding: '0'
  }), []);

  return (
    <div
      style={{
        width: '100% !important',
        display: 'flex',
        flexDirection: 'column',
        gap: '32px'
      }}
    >
      <ProfileHeader />
      <Row style={rowStyle}>
        <Col>
          <CustomerPersonas />
        </Col>
      </Row>

      <Row style={rowStyle}>
        <Col>
          <AIAnalysis />
        </Col>
      </Row>

      <Visualizations />

      <FloatingSummary />
    </div>
  );
}

export function FloatingSummary() {
  useEffect(() => {
    const floatingSummary = document.getElementById('floating-summary');
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      if (scrollTop > 50) {
        floatingSummary.style.display = 'none';
      } else {
        floatingSummary.style.display = 'block';
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const style = useMemo(() => ({
    bottom: '0',
    height: '200px',
    width: 'calc(100% - 62px)',
    padding: '16px',
    position: 'fixed',
    zIndex: '1'
    // right: '0'
  }), []);

  return (
    <Row id="floating-summary">
      <Col>
        <div
          className="bg-gradient-primary text-white"
          style={style}
        >
          <h1>
            Customer Personals Takeaways and Next Actions
          </h1>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod
            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
            quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
            fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </p>
        </div>
      </Col>
    </Row>
  );
}
